module.exports = __webpack_public_path__ + "static/media/03_tearsofhair.aa1c1280.jpg";